import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';


const styles = (theme) => ({
  root: {
  },
  active: {
    border: `2px solid ${theme.palette.facet.lightGray2}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
  },
  failingActiveBorder: {
    border: `2px solid ${theme.palette.error.main}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
  },
  passingActiveBorder: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
  },
  decentActiveBorder: {
    border: `2px solid ${theme.palette.warning.main}`,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2),
    marginLeft: -theme.spacing(2),
    marginRight: -theme.spacing(2),
  },
  rowHeader: {
    paddingBottom: theme.spacing(1),
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(0.5),
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

const getSuccessRateColor = (successRate) => {
  if (!successRate) {
    return 'primaryGray';
  }

  if (successRate > 80) {
    return 'secondary';
  }

  if (successRate < 60) {
    return 'error';
  }

  return 'warning';
};

const AggregatorRowDetails = ({
  className,
  classes,
  title,
  successLinks,
  successRate,
  failedLinks,
  isActive,
}) => {
  const successRateColor = getSuccessRateColor(successRate);

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.active]: isActive,
        [classes.failingActiveBorder]: isActive && successRateColor === 'error',
        [classes.passingActiveBorder]: isActive && successRateColor === 'secondary',
        [classes.decentActiveBorder]: isActive && successRateColor === 'warning',
      })}
    >
      <Box className={classes.headerContainer}>
        <Text className={classes.rowHeader} variant={'h2'} weight={'bold'} align={'left'} color={'primaryGray'} value={title} />
        {isActive && <Text color={'primaryGray'} weight={'bold'} align={'right'} value={'ACTIVE'} />}
      </Box>
      <Box className={classes.row}>
        <Box>
          <Text color={'primaryGray'} weight={'bold'} value={'Successful Links'} />
          <Text color={'primaryGray'} weight={'bold'} value={successLinks} align={'left'} />
        </Box>
        <Box>
          <Text color={'primaryGray'} weight={'bold'} value={'Failed Links'} />
          <Text color={'primaryGray'} weight={'bold'} value={failedLinks} align={'left'} />
        </Box>
        <Box>
          <Text color={successRateColor} weight={'bold'} value={'Success Rate'} />
          <Text color={successRateColor} weight={'bold'} value={successRate} align={'left'} />
        </Box>
      </Box>
    </Box>
  );
};

AggregatorRowDetails.defaultProps = {
  className: '',
  isActive: false,
};

AggregatorRowDetails.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  successLinks: PropTypes.string.isRequired,
  failedLinks: PropTypes.string.isRequired,
  successRate: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
};

export default withStyles(styles)(AggregatorRowDetails);
